import React, { useState, useEffect } from "react";
import '../styles/tiles.css';
import '../styles/other.css';
import { PieChart } from 'react-minimal-pie-chart';
import { Link, Navigate } from "react-router-dom";
import Moment from 'react-moment';
import Axios from 'axios';

// import utilities
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';

// import components
import RoundButton from '../components/RoundButton.js';
import BarChart from '../components/BarChart.js';
import BarChartTwo from '../components/BarChartTwo.js';
import DropdownItem from '../components/DropdownItem.js';
import FinDashboardPieGraph from '../components/FinDashboardPieGraph.js';

// import assets
import icon_graph_churches from '../assets/icon_dashboard.png';

class FinDashboard extends React.Component {
    setActualSection = this.props.setActualSection;

    constructor(props) {
        super(props);

        this.state = {
            graph_assets_current: ([{ title: 'Loading...', value: 100}, { title: 'Loading...', value: 100}]),
            graph_liabilities_current: ([{ title: 'Loading...', value: 100}, { title: 'Loading...', value: 100}]),
            graph_revenues_current: ([{ title: 'Loading...', value: 100}, { title: 'Loading...', value: 100}]),
            graph_expenses_current: ([{ title: 'Loading...', value: 100}, { title: 'Loading...', value: 100}]),

            graph_assets_past: ([{ title: 'Loading...', value: 100}, { title: 'Loading...', value: 100}]),
            graph_liabilities_past: ([{ title: 'Loading...', value: 100}, { title: 'Loading...', value: 100}]),
            graph_revenues_past: ([{ title: 'Loading...', value: 100}, { title: 'Loading...', value: 100}]),
            graph_expenses_past: ([{ title: 'Loading...', value: 100}, { title: 'Loading...', value: 100}]),

            showPopupChurchCategory: false,
            showPopupFilterByWho: false,

            selectedNatOrg: 0,
            selectedPeriod: 0,
            selectedLevel: 2,
            selectedCurrency: 1,

            listOfNatOrg: ([{id:1, label: "Organization 1"},{id:2, label: "Organization 2"},{id:3, label: "Organization 3"}]),
            listOfPeriods: ([{id:1, label: "Period 1"},{id:2, label: "Period 2"},{id:3, label: "Period 3"}]),
            listOfLevels: ([{id:2, label: "Level 2"},{id:3, label: "Level 3"}]),
            listOfCurrencies: ([{id:1, label: "Currency 1"},{id:2, label: "Currency 2"},{id:3, label: "Currency 3"}]),
        }

        this.refPopupChurchCategory = React.createRef();
        this.refInputFilterByWho = React.createRef();
    }

    getRandomColor = () => {
        var color = '#';
        let min = 75;
        let max = 200;
        var red = min + (Math.random() * (max - min));
        var green = min + (Math.random() * (max - min));
        var blue = min + (Math.random() * (max - min));

        return "rgb("+red+","+green+","+blue+")";

        for (var i = 0; i < 6; i++) {
            color += Math.floor(Math.random() * 10);
        }
        //return color;
    }

    getColor = (index, size) => {
        if(index != undefined && size != undefined){
            if(size <= 2){
                if(index == 0)return "rgb(217,211,232)";
                else if(index == 1)return "rgb(255,102,0)";
            }
            else if(size <= 5) {
                const shortList = ["rgb(255,102,0)", "rgb(234,213,49)", "rgb(33,213,147)", "rgb(85,110,230)", "rgb(250,80,179)"];
                return shortList[index];
            }
            else {
                const longList = ["rgb(255,102,0)", "rgb(255,174,119)", "rgb(234,213,49)", "rgb(240,228,137)", "rgb(33,213,147)", "rgb(34,230,158)", "rgb(85,110,230)", "rgb(142,159,234)", "rgb(250,80,179)", "rgb(255,173,221)"];
                return longList[index%10];
            }
        }
        else {
            var color = '#';
            let min = 75;
            let max = 200;
            var red = min + (Math.random() * (max - min));
            var green = min + (Math.random() * (max - min));
            var blue = min + (Math.random() * (max - min));

            return "rgb("+red+","+green+","+blue+")";
        }
    }

    componentDidMount(){
        this.setActualSection("fin_dashboard");

        window.addEventListener('click', this.onGlobalClick);

        this.loadData();
    }

    loadData = async () => {

        // stmt_tp_id=1 is for BalanceSheet, stmt_tp_id=2 is for Profit and Loss
        // side=1 is to select "Assets" or "Revenues", side=2 is to select "Liabilities" or "Expenses"
        // lvl=1 is top level, then is also lvl=2 and lvl=3

        var filterValuesCurrent = "&lvl="+this.state.selectedLevel+"&nt_org_id="+this.state.selectedNatOrg+"&ccy_id="+this.state.selectedCurrency+"&period_id="+this.state.selectedPeriod;

        var prevId = this.getPrevId(this.state.selectedPeriod);
        var filterValuesPast = "&lvl="+this.state.selectedLevel+"&nt_org_id="+this.state.selectedNatOrg+"&ccy_id="+this.state.selectedCurrency+"&period_id="+prevId;

        // GET CURRENT ASSETS (from Balance sheet)
        Axios.get('/api/rpt/subm/get?stmt_tp_id=1&side=1'+filterValuesCurrent).then(response => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            var array_assets_current = ([]);
            response.data.result.forEach((item, index) => {
                array_assets_current.push({"title": item.label, "value": item.amt, "color": ""+this.getColor(index, response.data.result.length)});
            });
            this.setState({ graph_assets_current: array_assets_current });
        });

        // GET CURRENT LIABILITIES (from Balance sheet)
        Axios.get('/api/rpt/subm/get?stmt_tp_id=1&side=2'+filterValuesCurrent).then(response => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            var array_liabilities_current = ([]);
            response.data.result.forEach((item, index) => {
                array_liabilities_current.push({"title": item.label, "value": item.amt, "color": ""+this.getColor(index, response.data.result.length)});
            });
            this.setState({ graph_liabilities_current: array_liabilities_current });
        });

        // GET CURRENT REVENUES (from Profit and loss)
        Axios.get('/api/rpt/subm/get?stmt_tp_id=2&side=1'+filterValuesCurrent).then(response => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            var array_revenues_current = ([]);
            response.data.result.forEach((item, index) => {
                array_revenues_current.push({"title": item.label, "value": item.amt, "color": ""+this.getColor(index, response.data.result.length)});
            });
            this.setState({ graph_revenues_current: array_revenues_current });
        });

        // GET CURRENT EXPENSES (from Profit and loss)
        Axios.get('/api/rpt/subm/get?stmt_tp_id=2&side=2'+filterValuesCurrent).then(response => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            var array_expenses_current = ([]);
            response.data.result.forEach((item, index) => {
                array_expenses_current.push({"title": item.label, "value": item.amt, "color": ""+this.getColor(index, response.data.result.length)});
            });
            this.setState({ graph_expenses_current: array_expenses_current });
        });

        // GET PAST ASSETS (from Balance sheet)
        Axios.get('/api/rpt/subm/get?stmt_tp_id=1&side=1'+filterValuesPast).then(response => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            var array_assets_past = ([]);
            response.data.result.forEach((item, index) => {
                array_assets_past.push({"title": item.label, "value": item.amt, "color": ""+this.getColor(index, response.data.result.length)});
            });
            this.setState({ graph_assets_past: array_assets_past });
        });

        // GET PAST LIABILITIES (from Balance sheet)
        Axios.get('/api/rpt/subm/get?stmt_tp_id=1&side=2'+filterValuesPast).then(response => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            var array_liabilities_past = ([]);
            response.data.result.forEach((item, index) => {
                array_liabilities_past.push({"title": item.label, "value": item.amt, "color": ""+this.getColor(index, response.data.result.length)});
            });
            this.setState({ graph_liabilities_past: array_liabilities_past });
        });

        // GET PAST REVENUES (from Profit and loss)
        Axios.get('/api/rpt/subm/get?stmt_tp_id=2&side=1'+filterValuesPast).then(response => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            var array_revenues_past = ([]);
            response.data.result.forEach((item, index) => {
                array_revenues_past.push({"title": item.label, "value": item.amt, "color": ""+this.getColor(index, response.data.result.length)});
            });
            this.setState({ graph_revenues_past: array_revenues_past });
        });

        // GET PAST EXPENSES (from Profit and loss)
        Axios.get('/api/rpt/subm/get?stmt_tp_id=2&side=2'+filterValuesPast).then(response => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            var array_expenses_past = ([]);
            response.data.result.forEach((item, index) => {
                array_expenses_past.push({"title": item.label, "value": item.amt, "color": ""+this.getColor(index, response.data.result.length)});
            });
            this.setState({ graph_expenses_past: array_expenses_past });
        });

        this.loadNatOrg();
        this.loadPeriods();
        this.loadCurrency();
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.onGlobalClick);
    }

    /* This method is triggered on every click on screen and is checking if some popup is opened nad user clicked out of this popup so it would close that popup in that situation */
    onGlobalClick = (e) => {
        if ( this.refPopupChurchCategory.current && (!this.refPopupChurchCategory.current.contains(e.target)) && this.state.showPopupChurchCategory) {
            // user clicked out of the PopupChurchCategory and that popup is now opened
            this.setState({ showPopupChurchCategory: false })
        }
        if ( this.state.showPopupFilterByWho ) this.refInputFilterByWho.current.focus();
    }

    getPrevId = (currentId) => {
        if(currentId == 0)return -1;
        for(let oneRow of this.state.listOfPeriods){
            if(oneRow.id == currentId)return oneRow.prev_id;
        }
        return -1;
    }

    loadNatOrg = () => {
        Axios.get('/api/nt_org/get').then(response => {
            this.setState({ listOfNatOrg: [] });
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            this.setState({ listOfNatOrg: response.data.result });
        });
    }

    loadPeriods = () => {
        Axios.get('/api/period/get').then(response => {
            this.setState({ listOfPeriods: [] });
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            this.setState({ listOfPeriods: response.data.result });
        });
    }

    loadCurrency = () => {
        Axios.get('/api/ccy/get').then(response => {
            this.setState({ listOfCurrencies: [] });
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }

            var listOfCurrencies = ([]);
            response.data.result.forEach((item, index) => {
                listOfCurrencies.push({id: item.id, label: ""+item.iso_code});
            });
            this.setState({ listOfCurrencies: listOfCurrencies });
        });
    }

    onNatOrgSelected = async (id) => {
        await this.setState({ selectedNatOrg: id });
        this.loadData();
    }

    onLevelSelected = async (id) => {
        await this.setState({ selectedLevel: id });
        this.loadData();
    }

    onPeriodSelected = async (id) => {
        await this.setState({ selectedPeriod: id });
        this.loadData();
    }

    onCurrencySelected = async (id) => {
        await this.setState({ selectedCurrency: id });
        this.loadData();
    }

    getCurrencyName = () => {
        for(let oneRow of this.state.listOfCurrencies){
            if(oneRow.id == this.state.selectedCurrency)return oneRow.label;
        }
    }

    render() {
        return(
                <div className="verticalStack flex" style={{height: "calc(100vh - 80px)", overflowY: "scroll"}}>
                    <div className="horizontalStackCenter universalTableListingBar">
                        <span className="fontPoppinsRegular13Gray">{"Financial Dashboard"}</span>
                        <div className="flex"/>
                        <span className="fontPoppinsRegular13Gray onHoverToOrange clickable">{"Download PDF"}</span>
                    </div>

                    <div className="universalTile" style={{marginBottom: 20, marginLeft: 20, marginRight: 20}}>

                        <div className="horizontalStack" style={{position: "relative", backgroundColor: "var(--lightest-gray)"}}>

                            <div className="verticalStack flex" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 20, paddingBottom: 20}}>
                                <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>National Organization:</span>
                                <select className="universalTextInput topMenuSelectBox" name="nt_org" id="nt_org" style={{}} value={this.state.selectedNatOrg} onChange={e => this.onNatOrgSelected(e.target.value)}>
                                    <option value="">All organizations</option>
                                    {this.state.listOfNatOrg.map(function (item) {
                                        return (
                                           <option value={item.id}>{item.label}</option>
                                        )
                                    }.bind(this))}
                                </select>
                            </div>

                            <div className="verticalStack flex" style={{paddingTop: 20, paddingRight: 20, paddingBottom: 20}}>
                                <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Level of Detail:</span>
                                <select className="universalTextInput topMenuSelectBox" name="level" id="level" style={{}} value={this.state.selectedLevel} onChange={e => this.onLevelSelected(e.target.value)}>
                                    {this.state.listOfLevels.map(function (item) {
                                        return (
                                           <option value={item.id}>{item.label}</option>
                                        )
                                    }.bind(this))}
                                </select>
                            </div>

                            <div className="verticalStack flex" style={{paddingTop: 20, paddingRight: 20, paddingBottom: 20}}>
                                <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Year:</span>
                                <select className="universalTextInput topMenuSelectBox" name="period" id="period" style={{}} value={this.state.selectedPeriod} onChange={e => this.onPeriodSelected(e.target.value)}>
                                    <option value=""></option>
                                    {this.state.listOfPeriods.map(function (item) {
                                        return (
                                           <option value={item.id}>{item.label}</option>
                                        )
                                    }.bind(this))}
                                </select>
                            </div>

                            <div className="verticalStack flex" style={{paddingTop: 20, paddingRight: 20, paddingBottom: 20}}>
                                <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Currency:</span>
                                <select className="universalTextInput topMenuSelectBox" name="currency" id="currency" style={{}} value={this.state.selectedCurrency} onChange={e => this.onCurrencySelected(e.target.value)}>
                                    {this.state.listOfCurrencies.map(function (item) {
                                        return (
                                           <option value={item.id}>{item.label}</option>
                                        )
                                    }.bind(this))}
                                </select>
                            </div>
                        </div>


                    </div>

                    <div className="horizontalStack" style={{marginBottom: 20, marginLeft: 20, marginRight: 20}}>

                        <div className="verticalStack flex">
                            <FinDashboardPieGraph
                                title={"Assets"}
                                subtitle={this.state.selectedPeriod == 0 ? "Current Year" : "Selected Year"}
                                icon={icon_graph_churches}
                                data={this.state.graph_assets_current}
                                currencyIso={""+this.getCurrencyName()}
                            />
                        </div>

                        <div style={{height: 20, width: 20}}></div>

                        <div className="verticalStack flex">
                            <FinDashboardPieGraph
                                title={"Liabilities"}
                                subtitle={this.state.selectedPeriod == 0 ? "Current Year" : "Selected Year"}
                                icon={icon_graph_churches}
                                data={this.state.graph_liabilities_current}
                                currencyIso={""+this.getCurrencyName()}
                            />
                        </div>

                        <div style={{height: 20, width: 20}}></div>

                        <div className="verticalStack flex">
                            <FinDashboardPieGraph
                                title={"Revenues"}
                                subtitle={this.state.selectedPeriod == 0 ? "Current Year" : "Selected Year"}
                                icon={icon_graph_churches}
                                data={this.state.graph_revenues_current}
                                currencyIso={""+this.getCurrencyName()}
                            />
                        </div>

                        <div style={{height: 20, width: 20}}></div>

                        <div className="verticalStack flex">
                            <FinDashboardPieGraph
                                title={"Expenses"}
                                subtitle={this.state.selectedPeriod == 0 ? "Current Year" : "Selected Year"}
                                icon={icon_graph_churches}
                                data={this.state.graph_expenses_current}
                                currencyIso={""+this.getCurrencyName()}
                            />
                        </div>

                    </div>

                    <div className="horizontalStack" style={{marginBottom: 20, marginLeft: 20, marginRight: 20}}>

                        <div className="verticalStack flex">
                            <FinDashboardPieGraph
                                title={"Assets"}
                                subtitle={"Previous Year"}
                                icon={icon_graph_churches}
                                data={this.state.graph_assets_past}
                                currencyIso={""+this.getCurrencyName()}
                            />
                        </div>

                        <div style={{height: 20, width: 20}}></div>

                        <div className="verticalStack flex">
                            <FinDashboardPieGraph
                                title={"Liabilities"}
                                subtitle={"Previous Year"}
                                icon={icon_graph_churches}
                                data={this.state.graph_liabilities_past}
                                currencyIso={""+this.getCurrencyName()}
                            />
                        </div>

                        <div style={{height: 20, width: 20}}></div>

                        <div className="verticalStack flex">
                            <FinDashboardPieGraph
                                title={"Revenues"}
                                subtitle={"Previous Year"}
                                icon={icon_graph_churches}
                                data={this.state.graph_revenues_past}
                                currencyIso={""+this.getCurrencyName()}
                            />
                        </div>

                        <div style={{height: 20, width: 20}}></div>

                        <div className="verticalStack flex">
                            <FinDashboardPieGraph
                                title={"Expenses"}
                                subtitle={"Previous Year"}
                                icon={icon_graph_churches}
                                data={this.state.graph_expenses_past}
                                currencyIso={""+this.getCurrencyName()}
                            />
                        </div>

                    </div>
                </div>
        );
    }
}

export default FinDashboard;